import React, { useEffect, useState } from 'react';
import $ from "jquery";
function hasValue(arr, value) {
    var i = 0;
    while (i < arr.length) {
        if (arr[i] === value) {
            return true;
        }
        else {
            ++i;
        }
    }
    return false;
}
function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
}
function removeItemAll(arr, value) {
    var i = 0;
    while (i < arr.length) {
        if (arr[i] === value) {
            arr.splice(i, 1);
        }
        else {
            ++i;
        }
    }
    return arr;
}
const Module = ({ pll, element, formData, setFormData, attributes, options = {} }) => {
    let defaultOptions = {
        type: "simple",
        group: null,
        formationId: null,
        formationName: null,
        formationInformations: null,
        setPage: null,
        page: null,
        mandatory: false
    };
    let attrs = Object.assign(Object.assign({}, defaultOptions), options);
    if (attrs.formationName != null) {
        element.formationName = attrs.formationName;
    }
    if (attrs.formationInformations != null) {
        element.formationInformations = attrs.formationInformations;
    }
    const fId = `module${element.id}`;
    let modulesRaw = formData.modulesRaw;
    let modules = formData.modules;
    let formations = formData.formations;
    const [isChecked, setChecked] = useState(false);
    const countSelectedDays = (selectedModules, modules) => {
        let days = 0;
        selectedModules.forEach(element => {
            if (modules.hasOwnProperty(element)) {
                let module = modules[element];
                days += parseInt(module.days);
            }
        });
        return days;
    };
    useEffect(() => {
        // 
        setChecked(formData.modules.includes(element.id));
        return () => {
            // this now gets called when the component unmounts
        };
    }, []);
    const choiceModule = (e) => {
        e.preventDefault();
        if (attributes.formation) {
            element.formationName = attributes.formation.name;
            element.formationInformations = attributes.formation.informations;
        }
        modulesRaw.modules[element.id] = element;
        modules = [element.id];
        attrs.setPage(attrs.page + 1);
        let selectedDays = countSelectedDays(modules, modulesRaw.modules);
        setFormData(Object.assign(Object.assign({}, formData), { modules: modules, modulesRaw: modulesRaw, selectedDays: selectedDays }));
    };
    const handleChange = (e) => {
        let value = e.target.value;
        let lastId = modulesRaw.ids.hasOwnProperty(attrs.formationId) ? modulesRaw.ids[attrs.formationId] : null;
        // Store
        modulesRaw.modules[element.id] = element;
        // Remove element from modules before adding new one
        removeItemOnce(modules, parseInt(lastId));
        removeItemOnce(formations, parseInt(attrs.formationId));
        //
        modulesRaw.ids[attrs.formationId] = value;
        if (isChecked == false) {
            modules.push(parseInt(value));
            formations.push(parseInt(attrs.formationId));
            setChecked(true);
        }
        else {
            $(e.target).prop("checked", "");
            setChecked(false);
        }
        let selectedDays = countSelectedDays(modules, modulesRaw.modules);
        setFormData(Object.assign(Object.assign({}, formData), { modules: modules, formations: formations, modulesRaw: modulesRaw, selectedDays: selectedDays }));
    };
    const radioButton = (React.createElement("input", { type: "radio", onClick: handleChange, defaultChecked: isChecked, required: attrs.mandatory ? "required" : "", id: fId, name: attrs.group, value: element.id, disabled: !element.isAvailable }));
    const button = (React.createElement("button", { onClick: choiceModule, className: `Button ${element.isAvailable ? "active" : "disabled"}`, disabled: !element.isAvailable }, element.isAvailable ? pll("M'inscrire") : pll("Complet")));
    return (React.createElement("div", { className: `module ${element.visible ? "visible" : "hidden"}` },
        React.createElement("span", { className: "before-action" }, attrs.type == "multiple" ? radioButton : ""),
        React.createElement("label", { htmlFor: fId, className: "dates td", dangerouslySetInnerHTML: { __html: "<span class='b'>" + pll("Dates") + "</span><span>" + element.dates.formatted + "</span>" } }),
        React.createElement("label", { htmlFor: fId, className: "centres td" },
            React.createElement("span", { class: 'b' }, pll("Centre(s)")),
            React.createElement("span", null, element.centres.join("<br>"))),
        React.createElement("label", { htmlFor: fId, className: "locations td" },
            React.createElement("span", { class: 'b' }, pll("Lieux")),
            React.createElement("span", null, element.location)),
        React.createElement("label", { htmlFor: fId, className: "tickets td" },
            React.createElement("span", { class: 'b' }, pll("Places dispos")),
            React.createElement("span", null, element.tickets.available)),
        React.createElement("label", { htmlFor: fId, className: "ref td" },
            React.createElement("span", { class: 'b' }, pll("Référence")),
            React.createElement("span", null, element.reference)),
        React.createElement("span", { className: "after-action" }, attrs.type == "simple" ? button : "")));
};
export default Module;
